import { render } from "./CoinAccountComponent.vue?vue&type=template&id=788efd1e&scoped=true"
import script from "./CoinAccountComponent.vue?vue&type=script&lang=js"
export * from "./CoinAccountComponent.vue?vue&type=script&lang=js"

import "./CoinAccountComponent.vue?vue&type=style&index=0&id=788efd1e&lang=css"
import "./CoinAccountComponent.vue?vue&type=style&index=1&id=788efd1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788efd1e"]])

export default __exports__